<template>
  <div>
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{ editRoute ? $t("labels.edit_section") : $t("labels.add_section") }}
        </h2>
      </div>
    </div>
    <div class="addedit-folder center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-folder-card">
          <div v-if="ship_image && is_mapped">
            <h4>Ship Image:</h4>
            <div
              class="image-container mb-3"
              @mousemove="handleDragging($event)"
              @mouseup="stopDragging"
            >
              <img
                ref="ship_image"
                :src="ship_image"
                alt="ship-image"
                width="1000px"
                style="
                  min-width: 1000px;
                  max-height: 600px;
                  object-fit: contain;
                "
                height="600px"
                @mousemove="handleDragging($event)"
                @mouseup="stopDragging($event)"
                @touchend="stopDragging($event)"
                @touchcancel="stopDragging($event)"
              />
              <div
                class="pin"
                :style="{
                  left: location.x + 'px',
                  top: location.y + 'px',
                }"
                @mousedown="startDragging($event)"
                @mouseup="stopDragging($event)"
                @touchend="stopDragging($event)"
                @touchcancel="stopDragging($event)"
              >
                <div
                  class="text-white"
                  :class="location.color == 'red' ? 'red-pin' : 'yellow-pin'"
                  draggable="true"
                ></div>
              </div>
            </div>
          </div>
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mb-4">
              <label>{{ $t("labels.folder_name") }}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="folder_name"
                maxlength="100"
                v-model="folder_name"
                icon-no-border
                :placeholder="$t('labels.folder_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{
                errors.first("folder_name")
              }}</span>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mb-4">
              <label>{{ $t("labels.type") }}</label>
              <v-select
                v-model="vessel_type_id"
                :options="parentVesselTypes"
                :reduce="(parentVesselTypes) => parentVesselTypes.id"
                :value="$store.myValue"
                @input="setSelectedVesselType"
                label="name"
                class="mt-1"
                disabled
                v-validate="'required'"
              />
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mb-4">
              <label>{{ $t("labels.subtype") }}</label>
              <v-select
                v-model="vessel_sub_type_id"
                :options="subtypes"
                :reduce="(subtypes) => subtypes.id"
                :value="$store.myValue"
                :label="'name'"
                name="subtype"
                class="mt-1"
                v-validate="'required'"
                disabled
                @input="vesselSubTypeChange"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('subtype') }}</span>-->
            </div>
            <div
              v-if="ship_image"
              class="vx-col w-full md:w-1/2 pl-0 pr-0 mt-6 flex sm: justify-center md:justify-start align-items-center"
            >
              <label>Mapped Folder:</label>
              <vs-switch color="primary" v-model="is_mapped" class="ml-4">
                <span slot="on">Mapped</span>
                <span slot="off">Un-Mapped</span>
              </vs-switch>
            </div>

            <div class="vx-row w-full m-0">
              <div class="vx-col sm: w-full md:w-1/1 px-0 mb-4">
                <label>GA Plan Image</label>
                <file-picker
                  ref="filePicker"
                  :acceptFormat="['.jpg', '.jpeg', '.png']"
                  :isMultiple="false"
                ></file-picker>
              </div>
            </div>
          </div>

          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-folder"
              button="submit"
              >{{
                editRoute
                  ? $t("labels.update_section")
                  : $t("labels.add_section")
              }}</vs-button
            >
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import FilePicker from "@/components/file-picker.vue";
export default {
  components: {
    FilePicker,
  },
  data() {
    return {
      folder_name: null,
      is_mapped: false,
      ship_image: null,
      location: null,
      isDragging: false,
      parentVesselTypes: [],
      subtypes: [],
      vessel_type_id: null,
      vessel_sub_type_id: null,
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
    vessel_type() {
      return this.$route.params.vessel_type_id;
    },
    vessel_sub_type() {
      return this.$route.params.vessel_sub_type_id;
    },
  },
  mounted() {
    this.setValidationMessage();
    this.getParentVesselTypes();
    if (this.editRoute) {
      this.getFolder();
    } else {
      this.vessel_type_id = parseInt(this.vessel_type);
      this.vessel_sub_type_id = parseInt(this.vessel_sub_type);
      this.getSubtypes();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createUpdateFolder();
        }
      });
    },
    setSelectedVesselType() {
      this.vessel_sub_type_id = null;
      this.subtypes = [];
      this.getSubtypes();
    },
    async vesselSubTypeChange() {
      let response = await this.getHTTPGetResponse(
        "/vesselType/get/" + this.vessel_sub_type_id
      );
      if (response) {
        let data = response.data;
        let vesselType = data.vesselType;
        if (vesselType.ship_image_url)
          this.ship_image = vesselType.ship_image_url;
      }
    },
    async getParentVesselTypes() {
      let input = {
        only_parents: true,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let vesselTypes = response.data.vesselTypes;
        let filteredTypes = [];
        for (var i = 0; i < vesselTypes.length; i++) {
          let obj = { id: vesselTypes[i].id, name: vesselTypes[i].name };
          filteredTypes.push(obj);
        }
        this.parentVesselTypes = this.parentVesselTypes.concat(filteredTypes);
      }
    },
    async getSubtypes() {
      var input = {
        parent_id: this.parent_id,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let data = response.data.vesselTypes;
        this.subtypes = data;
      }
    },
    async createUpdateFolder() {
      let input = {
        folder_name: this.folder_name,
        vessel_type_id: this.vessel_type_id,
        vessel_sub_type_id: this.vessel_sub_type_id,
      };
      if (this.is_mapped && this.location && this.location.color == "red") {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      const files = this.$refs.filePicker.selectedFiles || [];

      input.location = this.is_mapped
        ? JSON.stringify({ x: this.location.x, y: this.location.y })
        : null;

      const formData = new FormData();
      for (const key in input) {
        if (Object.hasOwnProperty.call(input, key) && input[key] != null) {
          const element = input[key];
          formData.append(key, element);
        }
      }

      if (files.length && files[0].file) {
        formData.append(`ga_plan_image`, files[0].file);
      } else if (files.length) {
        formData.append("ga_plan_image", files[0].imageUrl);
      }

      let url = this.editRoute
        ? "/folders/update/" + this.editRoute
        : "/folders/create";
      let response = await this.getHTTPPostResponse(
        url,
        formData,
        "#create-folder",
        true
      );
      if (response) {
        this.$router.push({
          name: "ListSection",
          params: {
            vessel_type_id: this.vessel_type_id,
            vessel_sub_type_id: this.vessel_sub_type_id,
          },
        });
      }
    },
    async getFolder() {
      let response = await this.getHTTPGetResponse(
        "/folders/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let folder = data.folder;
        this.folder_name = folder.folder_name;
        this.ship_image = folder.vessel_sub_type.ship_image_url;
        this.location = this.ship_image
          ? JSON.parse(folder.location, true)
          : null;
        this.is_mapped = folder.location != null;
        this.vessel_type_id = folder.vessel_type_id;
        this.vessel_sub_type_id = folder.vessel_sub_type_id;
        this.getSubtypes();
        if (folder.ga_plan_image)
          this.$refs.filePicker.selectedFiles = [
            { imageUrl: folder.ga_plan_image, isImage: true },
          ];
      }
    },
    goBack() {
      history.back();
    },
    handleSwitch() {
      if (this.is_mapped) {
        let location = this.location;
        if (!location) {
          location = {
            x: 50,
            y: 50,
            color: "red",
          };
          this.location = location;
        }
      }
    },
    handleDragging(event) {
      if (this.isDragging) {
        const marker = this.location;
        marker.x = event.clientX - this.initialX;
        marker.y = event.clientY - this.initialY;
      }
    },
    startDragging(event) {
      event.preventDefault();
      this.isDragging = true;
      const marker = this.location;
      this.initialX = event.clientX - marker.x;
      this.initialY = event.clientY - marker.y;
    },
    stopDragging(event) {
      if (this.isDragging) {
        this.location.color = "yellow";
        this.isDragging = false;
      }
    },
  },
  watch: {
    is_mapped() {
      this.handleSwitch();
    },
  },
};
</script>
<style lang="scss" scoped>
.image-container {
  position: relative;
}

.yellow-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: #ec9a29;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.red-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.marker {
  position: absolute;
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pin {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, filter 0.3s ease;
  cursor: grab;
}
</style>
